import type {VTTProperties} from 'bitmovin-player';
import {
  CSSProperties,
  FC,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';
import {calculateVttRegionStyles} from '../../utils/vttUtils';

interface RegionProps {
  vtt?: VTTProperties;
}

export const Region: FC<PropsWithChildren<RegionProps>> = ({children, vtt}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [styles, setStyles] = useState<CSSProperties>({});

  useEffect(() => {
    if (!vtt || !ref.current) return;

    setStyles(calculateVttRegionStyles(vtt, ref.current));
  }, [vtt, ref]);

  if (!vtt?.region) {
    return <>{children}</>;
  } else {
    return (
      <div ref={ref} style={styles}>
        {children}
      </div>
    );
  }
};
